const prefix = 'dynamic-inserted-css-';

/**
 * insert css to the current page
 */
export function insertCSS(id, cssText) {
	if (typeof document === 'undefined') return;
	let style = document.getElementById(prefix + id);

	if (!style) {
		style = document.createElement('style');
		style.id = prefix + id;
		document.querySelector('head').appendChild(style);
	}

	if (style.textContent != cssText) {
		style.textContent = cssText;
	}

	return style;
}



// WEBPACK FOOTER //
// ./lib/helpers/insertCSS.js